import { type ReactElement } from 'react'
import { Modal, ModalBody, ModalHeader, Button } from '@stuller/stullercom/ui'
import { useToggle } from '@stuller/shared/util/react-hooks'
import { FormstackForm } from '@stuller/stullercom/feat/formstack'

/**
 * A component to show the serialized diamond special request modal
 */
function SerializedDiamondSpecialRequestModal (): ReactElement {
  const [isOpen, toggleIsOpen] = useToggle()
  const formName = 'diamonds_and_gemstones_special_order_form'

  return (
    <>
      <Button onClick={toggleIsOpen} color='primary'>
        Make a Request
      </Button>
      <Modal
        isOpen={isOpen}
        onToggle={toggleIsOpen}
      >
        <ModalHeader onToggle={toggleIsOpen}>
          Make a Request
        </ModalHeader>
        <ModalBody>
          <FormstackForm name={formName} />
        </ModalBody>
      </Modal>
    </>
  )
}

export {
  SerializedDiamondSpecialRequestModal
}
